import { useMutation, useQueryClient } from '@tanstack/react-query'
import { RobotApi } from 'api/RobotApi'
import type { DownloadMissionConfirmDataDto } from 'api/asyncapi'
import { DOWNLOAD_ERROR_SUCCESS, getDownloadErrorMessage } from 'utils/mqttErrorMessages'
import WebsocketManager, { SOCKET_MESSAGES } from 'utils/WebsocketManager'

const useDownloadMissionStatus = (robotId: number, robotSerial: number) => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, number>({
    mutationFn: RobotApi.uploadJobToRobot,

    onSuccess: (result, missionData) => {
      return new Promise<void>((resolve, reject) => {
        const wsPath = '/robot/' + robotSerial
        const timeoutId = setTimeout(() => {
          cleanup()
          handleErrorAndClear(`Download failed: Timeout'}`)
        }, 10000)

        const cleanup = () => {
          WebsocketManager.removeEventListener(SOCKET_MESSAGES.DOWNLOAD_MISSION_CONFIRM, onMessage, wsPath)
          clearTimeout(timeoutId)
        }

        const handleErrorAndClear = (errorMessage: string) => {
          cleanup()
          RobotApi.missionClearByRobotId(robotSerial)
            .catch(err => console.warn('Failed to clear mission state:', err))
            .finally(() => reject(new Error(errorMessage)))
        }

        const onMessage = (data: DownloadMissionConfirmDataDto) => {
          if (data.error === DOWNLOAD_ERROR_SUCCESS) {
            queryClient
              .invalidateQueries({ queryKey: ['robot', robotId] })
              .then(resolve)
              .catch(reject)
              .finally(cleanup)
          } else {
            cleanup()
            handleErrorAndClear(`Download failed: ${getDownloadErrorMessage(data.error)}`)
          }
        }

        WebsocketManager.addEventListener(SOCKET_MESSAGES.DOWNLOAD_MISSION_CONFIRM, onMessage, wsPath)
      })
    },
  })
}

export default useDownloadMissionStatus